
/**
 * ARLOS - SA Variants / Vision Theme
 * Swatch layout refresh
 */
(function () {
  'use strict';

  const selector =
    'variant-king-combined-listing';

  let refreshCount = 0;
  const maxRefreshes = 6;
  let refreshTimer = null;

  function refreshSwatches() {
    if (refreshCount >= maxRefreshes) return;

    if (!document.querySelector(selector)) return;

    refreshCount++;

    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function scheduleRefresh() {
    if (refreshCount >= maxRefreshes) return;

    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(
      refreshSwatches,
      250
    );
  }

  function initialize() {
    // Allow initial theme and app rendering.
    setTimeout(refreshSwatches, 350);
    setTimeout(refreshSwatches, 1200);
    setTimeout(refreshSwatches, 2500);

    // Detect swatches inserted after page load.
    const observer = new MutationObserver(function (changes) {
      const relevant = changes.some(function (change) {
        return Array.from(change.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;

          return (
            node.matches?.(selector) ||
            node.querySelector?.(selector) ||
            node.closest?.(selector)
          );
        });
      });

      if (relevant) scheduleRefresh();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Stop monitoring automatically.
    setTimeout(function () {
      observer.disconnect();
      clearTimeout(refreshTimer);
    }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
